import Line from "../../../../src/entities/Line";
import { Coord } from "../../../../src/types/Interface";

export default class LineManager {
  rLine1CirSide1 = new Line();
  rLine2CenSide2 = new Line();
  lLine1CirSide2 = new Line();
  lLine2CenSide1 = new Line();

  // r1 - circum - l1
  // r1 - side1 - l2
  // r2 - side2 - l1
  // r2 - center - l2

  constructor() {
  }

  draw([center, side1, side2, circum]: Coord[]) {
    this.rLine1CirSide1.draw(circum, side1);
    this.rLine2CenSide2.draw(center, side2);
    this.lLine1CirSide2.draw(circum, side2);
    this.lLine2CenSide1.draw(center, side1);
  }
}